import React from 'react';
import { AsideWrapper, WidgetPart, TabIcon } from './styles/BannerAsideTabBlock.styled';
import AsideMenuEventSearch from './AsideMenuEventSearch';
import AsideMenuGettingHere from './AsideMenuGettingHere';
import AsideMenuContactUs from './AsideMenuContactUs';

export default function AsideMenu({ dir }) {
  const lang = dir === 'rtl' ? 'ar' : 'en';
  const [displayContent, setDisplayContent] = React.useState('');
  const clickRef = React.useRef(null);

  React.useEffect(() => {
    const handleClick = (e) => {
      if (clickRef.current && !clickRef.current.contains(e.target)) setDisplayContent('');
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [displayContent]);

  return (
    <AsideWrapper ref={clickRef}>
      <WidgetPart>
        <TabIcon
          onClick={() => setDisplayContent(displayContent === 'eventsearch' ? '' : 'eventsearch')}
          selected={displayContent === 'eventsearch'}
        >
          <i className="icon-search" />
        </TabIcon>
        <AsideMenuEventSearch lang={lang} isVisible={displayContent === 'eventsearch'} dir={dir} />
      </WidgetPart>
      <WidgetPart>
        <TabIcon
          onClick={() => setDisplayContent(displayContent === 'gettinghere' ? '' : 'gettinghere')}
          className="gettinghere"
          selected={displayContent === 'gettinghere'}
        >
          <i className="icon-location" />
        </TabIcon>
        <AsideMenuGettingHere lang={lang} isVisible={displayContent === 'gettinghere'} dir={dir} />
      </WidgetPart>
      <WidgetPart>
        <TabIcon
          onClick={() => setDisplayContent(displayContent === 'contactus' ? '' : 'contactus')}
          className="contactus_icon"
          selected={displayContent === 'contactus'}
        >
          <i className="icon-contact" />
        </TabIcon>
        <AsideMenuContactUs lang={lang} isVisible={displayContent === 'contactus'} dir={dir} />
      </WidgetPart>
    </AsideWrapper>
  );
}
